import { CookieService } from '@travelata-libs/utils';

export const TOUR_CRITERIA_CHANGED_COOKIE = 'tourCriteriaChanged';

export const CHANGED_FIELD = {
  nights: 'nightRange',
  date: 'checkInDateRange',
} as const;

export type ChangedFieldName = (typeof CHANGED_FIELD)[keyof typeof CHANGED_FIELD];

const FIELD_SEPARATOR = '.';

let cookieService: CookieService | null = null;

function cookies(): CookieService {
  if (!cookieService) {
    cookieService = new CookieService();
  }
  return cookieService;
}

function hasDocument(): boolean {
  return typeof document !== 'undefined';
}

function sharedDomain(): string | undefined {
  if (!hasDocument()) {
    return undefined;
  }
  const labels = document.location.hostname.split(FIELD_SEPARATOR);
  return labels.length >= 2 ? labels.slice(-2).join(FIELD_SEPARATOR) : undefined;
}

function writeOptions(): { path: string; domain?: string } {
  const domain = sharedDomain();
  return domain ? { path: '/', domain } : { path: '/' };
}

export function readChangedFields(): ChangedFieldName[] {
  if (!hasDocument()) {
    return [];
  }
  const raw = cookies().get<string>(TOUR_CRITERIA_CHANGED_COOKIE);
  if (!raw) {
    return [];
  }
  return raw.split(FIELD_SEPARATOR).filter(Boolean) as ChangedFieldName[];
}

export function isFieldChanged(field: ChangedFieldName): boolean {
  return readChangedFields().includes(field);
}

export function addChangedField(field: ChangedFieldName): void {
  if (!hasDocument()) {
    return;
  }
  const fields = readChangedFields();
  if (fields.includes(field)) {
    return;
  }
  fields.push(field);
  cookies().set(TOUR_CRITERIA_CHANGED_COOKIE, fields.join(FIELD_SEPARATOR), writeOptions());
}

export function clearChangedFields(): void {
  if (!hasDocument()) {
    return;
  }
  cookies().set(TOUR_CRITERIA_CHANGED_COOKIE, '', writeOptions());
}
